import { keepIdentityIfEqual } from '@ipfabric/utils/fp/keepIdentityIfEqual';
import type { Eq } from 'fp-ts/Eq';
import { useRef } from 'react';

export const useKeepIdentityIfEqual = <T,>(eq: Eq<T>, value: T): T => {
  const previous = useRef(value);
  const current = keepIdentityIfEqual(eq)(previous.current)(value);
  previous.current = current;
  return current;
};
